module.exports = __webpack_public_path__ + "img/accounting-web-software-awards-2021--top-product--bookkeeping.f3e57687.webp";